import { useState } from "react";

type Props =
    {
        setProductSearch: (value: boolean) => void
        setCategorySearch: (value: boolean) => void
    }

export default function ProductCategorySearchBy({ setProductSearch, setCategorySearch }: Props) {
    const [checkedProductSearch, setCheckedProductSearch] = useState<boolean>(true);
    const [checkedCategorySearch, setCheckedCategorySearch] = useState<boolean>(false);

    const handleProductSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked)
            setCheckedCategorySearch(!event.target.checked);
        setCheckedProductSearch(event.target.checked);
        setProductSearch(event.target.checked);
    };

    const handleCategorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked)
            setCheckedProductSearch(!event.target.checked);
        setCheckedCategorySearch(event.target.checked);
        setCategorySearch(event.target.checked);
    };

    return (
        <div className="search-checkbox">
            <p className="search-check-title">Search by: </p>
            <input type="checkbox" id="product-search-check" checked={checkedProductSearch} onChange={handleProductSearch} />
            <p className="search-check-sub">Product</p>
            <input type="checkbox" id="category-search-check" checked={checkedCategorySearch} onChange={handleCategorySearch} />
            <p className="search-check-sub">Category</p>
        </div>
    )
}
